import { render, staticRenderFns } from "./selectroom.vue?vue&type=template&id=5fd0cfbc&scoped=true&"
import script from "./selectroom.vue?vue&type=script&lang=js&"
export * from "./selectroom.vue?vue&type=script&lang=js&"
import style0 from "./selectroom.vue?vue&type=style&index=0&id=5fd0cfbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0cfbc",
  null
  
)

export default component.exports